import { throttle } from '~/util/helpers/lodashLocal'
import { logWarn } from '~/util/helpers/time'
import { isArray } from '~/util/validators/baseComponentsValidators'

const PRAGMATIC_CURRENCY = 'UAH'
// const CASINO_ID = 'ppcam00000005442' // beton prod
// const CASINO_ID = 'ppckq00000017291' // beton stage
const CASINO_ID = '0000'

// const DGA_SCRIPT_SRC = process.env.PRAGMATIC_LIVE_DGA_SCRIPT_SRC
// const WS_URI = process.env.PRAGMATIC_LIVE_WS_URI
const DGA_SCRIPT_SRC = 'https://dga.pragmaticplaylive.net/dgaAPI.js'
const WS_URI = 'dga.pragmaticplaylive.net'

const PRAGMATIC_SCRIPT_FIELD = 'dga' // field that will be added to the window Object
const DEBOUNCE_CD_FOR_LIVE_TABLE_DATA_UPDATE_MS = 2000

let liveTableDataCash = {} // { [liveTableId]: liveTableData }

class PragmaticLivePlugin {
  constructor(store) {
    this.TableIdListToSub = new Set()
    this.AvailableTableIdList = new Set()
    this.store = store
    this.PragmaticScript = null
  }
  async init() {
    this.PragmaticScript = await this.loadPragmaticScript()
    if (!this.PragmaticScript) return

    const isConnected = await this.connectPragmaticWS()
    if (!isConnected) return

    this.setMessagesToStore = throttle(this.setMessagesToStore.bind(this), DEBOUNCE_CD_FOR_LIVE_TABLE_DATA_UPDATE_MS)

    this.getAvailableTableIdList()

    this.PragmaticScript.onMessage = this.onMessage.bind(this)
  }
  onMessage(data) {
    // so far two types of message: availableTableIdList and gameLiveInfoData
    const tableIdList = data?.tableKey
    if (isArray(tableIdList)) {
      this.AvailableTableIdList = new Set(tableIdList)
      this.store.dispatch('pragmaticLive/actSet_pragmaticLiveAvailableTableIdList', { tableIdList })
      this.subscribeAll()
    }
    else {
      if (!data || !data.tableId) return
      liveTableDataCash[data.tableId] = data
      this.setMessagesToStore()
    }
  }
  setMessagesToStore() {
    this.store.dispatch('pragmaticLive/actAddTo_liveTablesMessages', { messages: liveTableDataCash })
    liveTableDataCash = {}
  }
  async connectPragmaticWS() {
    return new Promise((resolve, reject) => {
      try {
        this.PragmaticScript.connect(WS_URI)
        this.PragmaticScript.onConnect = () => resolve(true)
      }
      catch (error) {
        logWarn('Failed to connect to Pragmatic live WS', error)
        reject(false)
      }
    })
  }
  async loadPragmaticScript() {
    return new Promise((resolve, reject) => {
      try {
        const script = document.createElement('script')
        script.src = DGA_SCRIPT_SRC
        script.async = true
        script.onload = () => resolve(window[PRAGMATIC_SCRIPT_FIELD])

        script.onerror = () => {
          logWarn('Failed to load DGA API onerror')
          reject()
        }
        document.body.appendChild(script)
      }
      catch (error) {
        logWarn('Failed to load DGA API catch')
        reject()
      }
    })
  }
  getAvailableTableIdList() {
    // get available table ids, goes to onMessage
    if (!this.PragmaticScript) return
    this.PragmaticScript.available(CASINO_ID)
  }
  subscribe(tableId) {
    if (process.server) return
    if (!this.AvailableTableIdList.has(tableId)) return
    try {
      window[PRAGMATIC_SCRIPT_FIELD].subscribe(CASINO_ID, tableId, PRAGMATIC_CURRENCY)
    }
    catch (error) {
      logWarn(`Failed to subscribe Pragmatic live table with tableId ${tableId}`, error)
    }
  }
  subscribeAll() {
    this.TableIdListToSub.forEach((tableId) => this.subscribe(tableId))
  }
  addToTableIdToList(tableId) {
    if (this.AvailableTableIdList.size) {
      this.subscribe(tableId)
    }
    this.TableIdListToSub.add(tableId)
  }
  disconnect() {
    try {
      if (!this.PragmaticScript) return
      this.PragmaticScript?.disconnect()
    }
    catch (error) {
      logWarn('PragmaticLive failed to disconnect')
    }
  }
  getTableIdList() {
    return this.TableIdListToSub
  }
  deleteTableIdList(tableId) {
    this.TableIdListToSub.delete(tableId)
  }
}

export default async ({ app, store }, inject) => {
  if (process.server) return

  const InstancePragmaticLivePlugin = new PragmaticLivePlugin(store)
  if (app.prototype) {
    app.prototype.$pragmaticLive = InstancePragmaticLivePlugin
  }
  inject('pragmaticLive', InstancePragmaticLivePlugin)

  app.router.afterEach((to, from) => {
    if (to.path === from.path) return
    InstancePragmaticLivePlugin.getAvailableTableIdList()
  })
}
